import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Images } from "../../../../assets/images";
import { H2 } from "../../AboutUs/Styles";

const members = [
  {
    name: "Justice K Kannan",
    role: "Chairman",
    title: "Retired Judge - Punjab & Haryana High Court",
    description: `Justice K. Kannan was formerly a Judge at High court of Punjab & Haryana, Chandigarh. He has also served as the Chairman of the Railways Claims Tribunal, Principal Bench, New Delhi. A trained mediator, Justice Kannan writes in leading newspapers on socio-legal issues. His principled declaration of assets as the first judge in India to do so brought a new paradigm for the entire judiciary to follow; and the weekly India Today named him among twenty heroes of 2009.
                
        Apart from an avid interest in medicine and law as an inter-disciplinary approach, he is also an expert in liability and succession laws. He has written a book on Accidents and Compensation Law (Wadhwa Butterworths LexisNexis, 2005) contributed to two titles of the Halsbury's Laws of India, Will  and Succession and Landlord and Tenant (both 1st and 2nd editions), edited and wrote Principles of Insurance by M.N.Srinivasan and K.Kannan (LexisNexis 2017).

        He is the editor of the renowned Modi's Textbook on Medical Jurisprudence and Toxicology, 2016 edition, Mulla's Indian Registration Act, Mulla's Sale of Goods Act and Partnership Act(Students' edition), and Paruck's Indian Succession Act (the last 3 editions).
                `,

    image: Images.JusticeKannan,
  },
  {
    name: "N. L. Rajah",
    role: "Founder & Director",
    title: "Sr. Advocate, Madras High Court",
    description: ` An advocate since 1986, Mr Rajah was designated as a Senior Advocate of the Madras High Court in 2016. In 2019, Mr Rajah was conferred "Living legend of Law" award by the Bar Association of India. He has been a Member of committee of Law Commission to suggest changes to Arbitration and Conciliation Act as also Consultee to Law Commission on Commercial Courts Act.

                Mr Rajah is a Trustee of the Palkhivala Foundation and a Founding Director of Nani Palkhivala Arbitration Centre. He is  Member, Arbitration Committee and Member, Heritage Committee of the Madras High Court.

                Author of Consumer Protection in India (Lexis Nexis), he has also edited a book on the history of Madras High Court and also a book on the splendour of the Madras HC building.
                
                `,
    image: Images.NlRaja,
  },
  {
    name: "Karthik Krishna",
    role: "Founder & Director",
    title: "MD, Telekonnectors",
    description: `
                An MBA from IIM Calcutta and a Computer Science Engineer from BITS Pilani, Karthik worked for over 15 years as the Managing Director of Deutsche Bank, London and their Singapore and New York offices, before returning to India in 2016. He currently runs a series of businesses within the Telekonnectors Group delivering telecom products and services. The focus of the group is product design and engineering.
              
                Group companies include Door Sabha Nigam Ltd., which is focused on telecom services including tele-conferencing solutions, while Telekonnectors focuses on designing and manufacturing telecom infrastructure equipment. Recent launches include PollStar and MultiCall. He is also a board member of Indian NBFC of KKR & Co Inc.`,

    image: Images.Karthik,
  },
  {
    name: "Viren Nanavati",
    role: "Director",
    title: "",
    description: `
                With a Mechanical Engineering degree from Madras University, and a Master's in Manufacturing Management from Coventry University,England, Viren's career spans 25 years across the fields of Operations, Purchase and Sales at Raj Petro.

                He is currently a Senior Director – Sales & Marketing, heading the domestic business, and is an active member of the Leadership Team at Raj Petro and a Joint Venture partner with Brenntag.
              `,
    image: Images.VirenNanavati,
  },
  {
    name: "Dr. C. Chandramouli",
    role: "Independent Director",
    title: "",
    description: `
              Dr. C. Chandramouli is a retired Indian Administrative Service (IAS) officer with over three decades of distinguished service in public administration. During his career, he held several senior leadership positions across central and state governments, contributing extensively to policy formulation, governance reforms, regulatory oversight, and institutional strengthening. He is widely respected for his deep understanding of administrative systems, compliance frameworks, and public-sector decision-making.

              Dr. Chandramouli brings to the Board a strong perspective on governance, ethics, stakeholder engagement, and policy alignment, offering strategic guidance that strengthens institutional credibility and long-term sustainability.
    `,
    image:
      "https://justact-api-uploads.s3.ap-south-1.amazonaws.com/13/1766137020162-e17c8a8b-92ed-4559-b939-39339f1b8128/Chandramouli.png",
  },
];

const BoardOfDirectors = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [needsExpand, setNeedsExpand] = useState(false);
  const descriptionRef = useRef(null);

  const totalSlides = members.length;

  useEffect(() => {
    setExpanded(false);
    if (descriptionRef.current) {
      setNeedsExpand(
        descriptionRef.current.scrollHeight >
          descriptionRef.current.clientHeight,
      );
    }
  }, [currentSlide]);

  // Auto-slide every 10 seconds, pause on hover
  useEffect(() => {
    if (isPaused) return;

    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 1000);

    return () => clearInterval(timer);
  }, [isPaused, totalSlides]);

  const goNext = () => {
    setIsPaused(true);
    setCurrentSlide((p) => (p + 1) % members.length);
  };

  const goPrev = () => {
    setIsPaused(true);
    setCurrentSlide((p) => (p === 0 ? members.length - 1 : p - 1));
  };

  useEffect(() => {
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;

    const handleTouchStart = (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    };

    const handleTouchMove = (e) => {
      endX = e.touches[0].clientX;
      endY = e.touches[0].clientY;
    };

    const handleTouchEnd = () => {
      const diffX = startX - endX;
      const diffY = startY - endY;

      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        if (diffX > 0) {
          goNext();
        } else {
          goPrev();
        }
      }
    };

    const slider = document.getElementById("board-slider");
    if (slider) {
      slider.addEventListener("touchstart", handleTouchStart);
      slider.addEventListener("touchmove", handleTouchMove);
      slider.addEventListener("touchend", handleTouchEnd);
    }

    return () => {
      if (slider) {
        slider.removeEventListener("touchstart", handleTouchStart);
        slider.removeEventListener("touchmove", handleTouchMove);
        slider.removeEventListener("touchend", handleTouchEnd);
      }
    };
  }, [currentSlide]);

  return (
    <MainWrapper>
      <ContentContainer>
        <H2 style={{ textAlign: "center", marginBottom: "50px" }}>
          Board of Directors
        </H2>

        <SliderContainer
          id="board-slider"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <ArrowButtonLeft onClick={goPrev} aria-label="Previous director">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 18L9 12L15 6"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ArrowButtonLeft>
          <ArrowButtonRight onClick={goNext} aria-label="Next director">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ArrowButtonRight>

          <CardsWrapper>
            <MemberCard>
              <ProfileImageContainer>
                <ProfileImage
                  key={members[currentSlide].image}
                  src={members[currentSlide].image}
                  alt={members[currentSlide].name}
                  // loading="lazy"
                />
              </ProfileImageContainer>

              <MemberInfo>
                <MemberDetails>
                  <MemberName>{members[currentSlide].name}</MemberName>
                  <MemberRole>{members[currentSlide].role}</MemberRole>
                  {members[currentSlide].title && (
                    <MemberTitle>{members[currentSlide].title}</MemberTitle>
                  )}
                </MemberDetails>

                <MemberDescription ref={descriptionRef} $expanded={expanded}>
                  {members[currentSlide].description}
                </MemberDescription>

                {needsExpand && (
                  <ReadMoreButton
                    onClick={() => {
                      setExpanded(!expanded);
                      setIsPaused(true);
                    }}
                  >
                    {expanded ? "Read Less" : "Read More"}
                  </ReadMoreButton>
                )}
              </MemberInfo>
            </MemberCard>
          </CardsWrapper>
        </SliderContainer>

        <PaginationContainer>
          {members.map((_, index) => (
            <PaginationDot
              key={index}
              $active={index === currentSlide}
              onClick={() => {
                setCurrentSlide(index);
                setIsPaused(true);
              }}
              aria-label={`Go to director ${index + 1}`}
            />
          ))}
        </PaginationContainer>
      </ContentContainer>
    </MainWrapper>
  );
};

export default BoardOfDirectors;

const ArrowButton = styled.button`
  position: absolute;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);

  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.9);

  background: rgba(255, 255, 255, 0.95);
  color: #293461;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #00818a;
    color: white;
    transform: translateY(-50%) scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 129, 138, 0.3);
  }

  &:active {
    transform: translateY(-50%) scale(0.95);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    top: 180px;
    transform: translateY(0);

    svg {
      width: 20px;
      height: 20px;
    }
  }

  @media (max-width: 480px) {
    width: 36px;
    height: 36px;
    top: 160px;
  }
`;

const ArrowButtonLeft = styled(ArrowButton)`
  left: 16px;

  @media (max-width: 768px) {
    left: 12px;
  }

  @media (max-width: 480px) {
    left: 8px;
  }
`;

const ArrowButtonRight = styled(ArrowButton)`
  right: 16px;

  @media (max-width: 768px) {
    right: 12px;
  }

  @media (max-width: 480px) {
    right: 8px;
  }
`;

export const MainWrapper = styled.section`
  width: 100%;
  background: ${({ color }) => (color ? color : "#e6f3f4")};
  padding: clamp(3rem, 6vw, 5rem) clamp(1rem, 3vw, 2rem);
  box-sizing: border-box;

  @media (min-width: 1600px) {
    padding: 6rem 4rem;
  }
`;

export const ContentContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
`;

const SliderContainer = styled.div`
  position: relative;
  overflow: visible;
  border-radius: clamp(12px, 2vw, 20px);
  padding: 0;

  @media (max-width: 768px) {
    overflow: visible;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0;
`;

const MemberCard = styled.div`
  background: white;
  border-radius: clamp(16px, 2vw, 24px);
  padding: clamp(2rem, 4vw, 3rem);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  width: 100%;
  max-width: 100;
  height: 720px;
  margin: 0 auto;

  @media (max-width: 1024px) {
    min-height: 720px;
  }

  @media (max-width: 768px) {
    min-height: 680px;
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    min-height: 640px;
  }
`;

const ProfileImageContainer = styled.div`
  width: clamp(160px, 20vw, 220px);
  height: clamp(160px, 20vw, 220px);
  border-radius: 50%;
  overflow: hidden;
  border: 5px solid #f8f9fa;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  box-shadow:
    0 10px 30px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  margin-bottom: clamp(0.5rem, 2vw, 1rem);
  flex-shrink: 0;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: scale(1.05);
    box-shadow:
      0 15px 40px rgba(0, 0, 0, 0.2),
      0 0 30px rgba(0, 131, 140, 0.15);
  }

  @media (max-width: 768px) {
    width: clamp(140px, 35vw, 180px);
    height: clamp(140px, 35vw, 180px);
    border-width: 4px;
  }

  @media (max-width: 480px) {
    width: 140px;
    height: 140px;
  }
`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;

  @media (max-width: 1024px) {
    transition: none;
  }
`;

const MemberInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(1rem, 2.5vw, 1.5rem);
  width: 100%;
  align-items: center;
  text-align: center;

  @media (max-width: 768px) {
    gap: clamp(0.75rem, 2vw, 1rem);
  }
`;

const MemberDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: clamp(0.375rem, 1vw, 0.625rem);
  width: 100%;
`;

const MemberName = styled.h3`
  font-family: openSans-SemiBold, sans-serif;
  font-weight: 600;
  font-size: clamp(1rem, 2.5vw, 1.5rem);
  color: #293461;
  margin: 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: clamp(1.125rem, 5vw, 1.5rem);
  }
`;

const MemberRole = styled.p`
  font-family: openSans-SemiBold, sans-serif;
  font-weight: 600;
  font-size: clamp(0.85rem, 2vw, 1.125rem);
  color: #00818a;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: clamp(0.875rem, 4vw, 1.125rem);
  }
`;

const MemberTitle = styled.p`
  font-family: openSans-SemiBold, sans-serif;
  font-size: clamp(0.8rem, 2vw, 1rem);
  color: #293461;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: clamp(0.8125rem, 3.5vw, 1rem);
  }
`;

const MemberDescription = styled.p`
  font-family: openSans-Regular, sans-serif;
  font-size: 1rem;
  line-height: 1.6;
  color: #293461;
  margin: 0;
  width: 100%;
  white-space: pre-line;
  text-align: left;

  display: -webkit-box;
  -webkit-line-clamp: ${({ $expanded }) => ($expanded ? "unset" : 4)};
  -webkit-box-orient: vertical;

  overflow: ${({ $expanded }) => ($expanded ? "auto" : "hidden")};
  max-height: ${({ $expanded }) =>
    $expanded ? "200px" : "calc(1rem * 1.6 * 4)"};
`;

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  margin-top: clamp(1.5rem, 3vw, 2.5rem);
  padding: 0.5rem 0;
`;

const PaginationDot = styled.button`
  width: clamp(10px, 2.5vw, 14px);
  height: clamp(10px, 2.5vw, 14px);
  border-radius: 50%;
  border: none;
  background: ${({ $active }) =>
    $active ? "#00818a" : "rgba(0, 129, 138, 0.3)"};
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;

  &:hover {
    background: #00818a;
    transform: scale(1.3);
  }

  &:focus {
    outline: 2px solid #00818a;
    outline-offset: 3px;
  }

  @media (max-width: 768px) {
    width: 10px;
    height: 10px;
  }
`;

const ReadMoreButton = styled.button`
  background: none;
  border: none;
  color: #00818a;
  font-family: openSans-SemiBold, sans-serif;
  font-size: 0.95rem;
  cursor: pointer;
  margin-top: 0.5rem;
`;
